export const RefundReason: Record<string, any> = {
  duplicate: 'Duplicate',
  fraudulent: 'Fraudulent',
  requested_by_customer: 'Requested by customer',
}
